import React from 'react';
import en from '../translations/en.json';

/**
 * Get a plain-text message by key, with optional string variable interpolation.
 * e.g. t('Page.schemaTitle', { siteTitle: 'gitribe' })
 *      → "Custom Software Development Company | gitribe"
 */
export const t = (id, values = {}) => {
  let str = en[id];
  if (str === undefined) return id;
  Object.entries(values).forEach(([key, val]) => {
    str = str.replace(new RegExp(`\\{${key}\\}`, 'g'), val);
  });
  return str;
};

/**
 * Get a message that contains React-element placeholders (e.g. {highlightText}, {lineBreak}).
 * Returns an array of strings and React elements that React will render correctly.
 *
 * e.g. tJsx('SectionWhyUs.title', { highlightText: <span>Why choose</span>, lineBreak: <br /> })
 */
export const tJsx = (id, values = {}) => {
  const str = en[id];
  if (str === undefined) return [id];
  const tokens = str.split(/(\{[^}]+\})/);
  return tokens
    .filter(token => token !== '')
    .map((token, i) => {
      const match = token.match(/^\{([^}]+)\}$/);
      const content = match && values[match[1]] !== undefined ? values[match[1]] : token;
      return <React.Fragment key={i}>{content}</React.Fragment>;
    });
};

export default en;
